// src/components/Future.jsx
import React from 'react';
import './Future.css';

export default function Future() {
  return (
    <section id="future" className="future-section-wrapper">
      <div className="future-main-container">
        
        {/* ================= OUT-OF-BOUNDS TITEL ================= */}
        <div className="future-header-block">
          <img src="/images/Future/future_title.png" alt="Future Vision" className="future-title-img" />
        </div>

        {/* ================= CONTENT FLEX ROW ================= */}
        <div className="future-content-flex">
          
          {/* LINKERKOLOM: De Startup-visie tekst */}
          <div className="future-text-housing-550">
            <h3 className="h3-style">A STARTUP ROADMAP</h3>
            <h1 className="h1-style">from academic potential to real-world implementation</h1>
            
            <p className="p-style" style={{ marginTop: '15px' }}>
              I find designing and engineering for the pediatric healthcare context incredibly rewarding. It sits at the intersection of my passion for bringing about immediate, positive human impact with the personal intellectual challenge of navigating a complex network of stakeholders.
            </p>

            <p className="p-style" style={{ marginTop: '12px' }}>
              After graduation, I will turn my design vision into action by transitioning OverDeTop into an innovative MKB startup. The momentum generated during my FMP has already laid the groundwork. The Mosakids Pediatric Hospital namely already expressed an interest in becoming the first customer. 
            </p>

            <p className="p-style" style={{ marginTop: '12px' }}>
              Through personal networking and the TU/e contest, I have already secured partnerships with the TU/e Knowledge Transfer Office (KTO), and VieCuri, with whom I’ll be looking into funding, patenting and additional validations. Furthermore, connections are present with industry leaders like Unitron, Achmea and Zumtobel for consultancies and refining the technological infrastructure and component selection.
            </p>

            <p className="p-style" style={{ marginTop: '12px' }}>
              The upcoming months will therefore focus on extended clinical trials and optimizing the mechanical assembly process. By early 2027, I aim to deploy OverDeTop within various specialized pediatric hospitals in The Netherlands (beachhead market). Plans have been made to, thereafter, scale towards adjacent sectors such as geriatric and special needs care.
            </p>
          </div>

          {/* RECHTERKOLOM: future_pic.png */}
          <div className="future-visual-wrapper">
            <img src="/images/Future/future_pic.png" alt="Timo pitching OverDeTop Future" className="future-main-img" />
          </div>

        </div>

        <div className="piv-references-section">
          <h2 >references</h2>

          <div className="piv-references-container">
          <p className="p-ref">
            Balik, B. (2012). Patient-and Family-Centredness: Growing a Sustainable Culture.<em>Healthcare Quarterly, 15</em>(Special Issue).  <a href="https://doi.org/10.12927/hcq.2012.23154" target="_blank" rel="noreferrer">https://doi.org/10.12927/hcq.2012.23154</a>        
          </p>       
          <p className="p-ref">
            Consolvo, S., McDonald, D. W., & Landay, J. A. (2009). Theory-driven design strategies for technologies that support behavior change in everyday life. <em>Proceedings of the SIGCHI Conference on Human Factors in Computing Systems, </em>405-414.<a href="https://doi.org/10.1145/1518701.1518766" target="_blank" rel="noreferrer">https://doi.org/10.1145/1518701.1518766</a>
          </p>
          <p className="p-ref">
            França, R. P., Monteiro, A. C. B., Arthur, R., & Iano, Y. (2021). Overview of Ubiquitous Computing and a Modern Look in Current Times. In <em>Integration of WSNs into Internet of Things</em> (1st ed., pp. 45–63). CRC Press. <a href="https://doi.org/10.1201/9781003107521-3" target="_blank" rel="noreferrer">https://doi.org/10.1201/9781003107521-3</a>
          </p>

          <p className="p-ref">
            IDEO U. (n.d.). <em>Design Thinking Framework, Innovation & Methodology.</em> <a href="https://www.ideou.com/pages/design-thinking" target="_blank" rel="noreferrer">https://www.ideou.com/pages/design-thinking</a>
          </p>

          <p className="p-ref">
            Lappset. (n.d.). <em>Wilhelmina Kinderziekenhuis Utrecht.</em> <a href="https://www.lappset.nl/projecten/wilhelmina-kinderziekenhuis-utrecht/" target="_blank" rel="noreferrer">https://www.lappset.nl/projecten/wilhelmina-kinderziekenhuis-utrecht/</a>
          </p>

          <p className="p-ref">
            Lovei, P., Noortman, R., & Funk, M. (2022). Introduction to Data-Enabled design. <em>CHI Conference on Human Factors in Computing Systems Extended Abstracts</em>, 1–3. <a href="https://doi.org/10.1145/3491101.3503749" target="_blank" rel="noreferrer">https://doi.org/10.1145/3491101.3503749</a>
          </p>

          <p className="p-ref">
            Ryan, R. M., & Deci, E. L. (2000). Self-determination theory and the facilitation of intrinsic motivation, social development, and well-being. <em>American Psychologist, 55</em>(1), 68–78. <a href="https://doi.org/10.1037/0003-066X.55.1.68" target="_blank" rel="noreferrer">https://doi.org/10.1037/0003-066X.55.1.68</a>
          </p>

          <p className="p-ref">
            Sætra, H. S. (2023). Introduction. In <em>Technology and Sustainable Development: The Promise and Pitfalls of Techno-Solutionism</em> (1st ed., pp. 1–9). Routledge. <a href="https://doi.org/10.1201/9781003325086-1" target="_blank" rel="noreferrer">https://doi.org/10.1201/9781003325086-1</a>
          </p>

          <p className="p-ref">
            Technicare. (n.d.). <em>Infuuts.</em> <a href="https://technicare.nl/producten/infuusfiets-infuuts/" target="_blank" rel="noreferrer">https://technicare.nl/producten/infuusfiets-infuuts/</a>
          </p>
        </div>
        </div>

      </div>
    </section>
  );
}